import React, { Component } from 'react'
import Link from '../utils/link'
import Plyr from '../components/plyr'

class PMInformation extends Component {

  _getVideoID(url) {
    if (!url) return null
    let regExp = /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#&?]*).*/
    let match = url.match(regExp)
    return match && match.length > 1 && match[1]
  }

  render() {

    const {
      logo, content,
      ownersImage, ownersHeading, ownersContent, ownersList, ownersButtonLink, ownersButtonText,
      tennantsImage, tennantsHeading, tennantsContent, tennantsList, tennantsButtonLink, tennantsButtonText, video
    } = this.props

    const ytbanner = this._getVideoID(video)

    return (
      <section className='property-management-information' data-color='#FFFFFF'>
        <div className='property-management-information__inner'>
          { logo && <img className="logo" src={logo?.localFile?.publicURL} alt={`Whitefox Advocacy`} /> }
          { ytbanner &&
            <div className='property-management-information__video'>
              <div className='property-management-information__video__wrapper'>
                <Plyr
                  type="youtube"
                  videoId={ytbanner}
                  autoplay={false}
                  muted={false}
                  urls={{
                    youtube: {
                      api: `https://noembed.com/embed?url=${0}`
                    }
                  }}
                />
              </div>
            </div>
          }
          
          <div className='property-management-information__intro' dangerouslySetInnerHTML={{ __html: content }}/>
          <div className='property-management-information__items'>
            <div className='property-management-information__content'>
              <div>
                { ownersImage && <img src={ownersImage.localFile.publicURL} alt={ownersHeading} /> }
                <h6>{ownersHeading}</h6>
                <div className='content' dangerouslySetInnerHTML={{ __html: ownersContent }} />
              </div>
              <Link className='contactbtn' to={ownersButtonLink}>{ownersButtonText}</Link>
            </div>
            <div className='property-management-information__content'>
              <div>
                { tennantsImage && <img src={tennantsImage.localFile.publicURL} alt={tennantsHeading} /> }
                <h6>{tennantsHeading}</h6>
                <div className='content' dangerouslySetInnerHTML={{ __html: tennantsContent }} />
              </div>
              <Link className='contactbtn' to='#property-search'>{tennantsButtonText}</Link>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default PMInformation
